import React, { useState, useEffect } from 'react';
import { getUserPaymentDoneLead } from '../../redux/action/request';
import { Eye } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { routes } from '../../contant';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import DatePicker from 'react-datepicker';
import {
  getUserActivityPonts,
  getAllUsersPaymentDoneLead,
} from '../../redux/action/request';
import { useDispatch, useSelector } from 'react-redux';
const getCurrentMonthDates = () => {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1); // 1st day of current month
  const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of current month

  return {
    startDate: startDate.toISOString().split('T')[0], // Format as YYYY-MM-DD
    endDate: endDate.toISOString().split('T')[0], // Format as YYYY-MM-DD
  };
};
const ActivityPoints = () => {
  const formatDate = (isoDate) => {
    return new Date(isoDate).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short', // "Mar"
      day: '2-digit', // "07"
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true, // Use AM/PM format
    });
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [date, setDate] = useState({ startDate: null, endDate: null });

  useEffect(() => {
    setDate(getCurrentMonthDates()); // Ensure getCurrentMonthDates() returns Date objects
  }, []);

  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [QRCode, setQRCode] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { userActivityData } = useSelector((state) => state.auth);
  const { leads } = useSelector((state) => state.auth);
  const { paidRequests } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getUserActivityPonts());
  }, [1000]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [1000]);

  const [editUser, setEditUser] = useState(null);

  const handleSaveEdit = () => {
    const data = {
      email: editUser?.email,
      name: editUser?.name,
      phone: editUser?.phone,
      userType: editUser?.userType,
    };
  };
  const handleExport = () => {
    const exportData = userActivityData.map((data) => ({
      _id: data.user?._id,
      name: data.user?.name,
      address: data.user?.address,
      profilePicture: data.user?.profilePhoto,
      verified: data.user?.verified,
      registerDate: data.user?.registerDate,
      totalRequests: data?.totalRequests,
      totalActivityPoints: data?.totalActivityPoints,
      lastRequestDate: data?.lastRequestDate,
      UPIID: data?.user?.upiID,
    }));

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert the modified JSON data into a worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Requests Data');

    // Generate and download the Excel file
    XLSX.writeFile(wb, `users_activity_points_list.xlsx`);
  };
  const [isModelOpen, setIsModelOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    employeeCode: '',
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      formData.name &&
      formData.email &&
      formData.password &&
      formData.employeeCode
    ) {
    } else {
      toast.error('Please fill in all required fields');
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    navigate(routes.signin);
  };
  const [isToolTipOpen, setIsToolTipOpen] = useState(null);
  const openToolTip = (userId) => setIsToolTipOpen(userId);
  const closeToolTip = () => setIsToolTipOpen(null);
  const confirmDelete = (userId) => {};
  const [userName, setUserName] = useState('');
  const donwnloadNewExcel = () => {
    const exportData = paidRequests.map((data) => ({
      _id: data.userDetails?._id,
      name: data.userDetails?.name,
      profilePicture: data.userDetails?.profilePhoto,
      upiID: data.userDetails?.upiID,
      phone: data.userDetails?.phone,
      companyName: data?.requestData?.paymentDetail?.companyName,
      activityPointsReceived:
        data?.requestData?.paymentDetail?.activityPointsReceived,
      premiumAmount: data?.requestData?.paymentDetail?.premiumAmount,
      paymentDate: data?.requestData?.paymentDate,
      verification: data?.requestData?.paymentVarified ? 'Done' : 'Pending',
    }));

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert the modified JSON data into a worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Requests Data');

    // Generate and download the Excel file
    XLSX.writeFile(wb, `activity_points_list.xlsx`);
  };
  return (
    <div className='p-6 bg-gray-100 min-h-screen'>
      <ToastContainer />

      {!loading ? (
        <>
          <div className='flex items-center justify-between bg-[#FFFFFF] p-2'>
            <h1 className='text-2xl font-bold'>Activity Points</h1>
            <div className='ml-auto flex items-center space-x-4'>
              <span
                onClick={() => handleExport()}
                className='px-4 py-2 bg-[#1E90FE] text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-colors duration-300 ease-in-out cursor-pointer'
              >
                Export Excel
              </span>
              <span
                onClick={() => {
                  setOpenModal(true);
                  dispatch(getAllUsersPaymentDoneLead(date));
                }}
                className='px-4 py-2 bg-[#1E90FE] text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-colors duration-300 ease-in-out cursor-pointer'
              >
                View All
              </span>
            </div>
          </div>

          <div className='overflow-x-auto'>
            <table className='min-w-full table-auto'>
              <thead className='text-gray-600 uppercase text-sm leading-normal'>
                <tr>
                  <th className='py-3 px-6 text-left'>User Name</th>
                  <th className='py-3 px-6 text-left'>Phone</th>
                  <th className='py-3 px-6 text-left'>Type</th>
                  <th className=' text-left'>Total Lead</th>
                  <th className=' text-center'>Total Activity Points</th>
                  <th className=' text-center'>Lead History</th>
                  <th className=' text-center'>Last Lead Date</th>
                </tr>
              </thead>

              <tbody className='text-gray-700 text-sm'>
                {userActivityData.map((user, index) => (
                  <tr
                    key={index}
                    className={`border-b border-gray-200 ${
                      index % 2 === 0 ? 'bg-gray-100' : 'bg-white'
                    }`}
                  >
                    <td className='py-3 px-6 text-left'>{user.user?.name}</td>
                    <td className='py-3 px-6 text-left'>{user.user?.phone}</td>
                    <td className='py-3 px-6 text-left '>
                      <span
                        className={
                          user.user?.userType === 'Admin'
                            ? `p-1 rounded bg-[green] text-[white]`
                            : user.user?.userType === 'ProLeadPartner'
                            ? `p-1 rounded bg-[#1E90FE] text-[white]`
                            : `p-1 rounded bg-[#32CD33] text-[white]`
                        }
                      >
                        {user.user?.userType === 'ProLeadPartner'
                          ? 'Pro Lead Partner'
                          : user.user?.userType === 'Admin'
                          ? 'Admin'
                          : 'Employee'}
                      </span>
                    </td>
                    <td className=' justify-center items-center pl-8'>
                      {user.totalRequests ? (
                        <strong>{user.totalRequests}</strong>
                      ) : (
                        <strong>{user.totalRequests}</strong>
                      )}
                    </td>
                    <td className='py-3 px-6 text-center'>
                      <strong>{user.totalActivityPoints}</strong>
                    </td>

                    <td className='py-3 px-6 text-center'>
                      <strong
                        onClick={() => {
                          setIsModelOpen(true);
                          console.log(user?.user._id);
                          setUserName(user?.user?.name);
                          dispatch(getUserPaymentDoneLead(user?.user._id));
                        }}
                      >
                        <Eye />
                      </strong>
                    </td>

                    <td className='py-3 px-6 text-center flex justify-center space-x-4 relative'>
                      {user.lastRequestDate ? (
                        <>
                          {' '}
                          {new Date(user.lastRequestDate).toLocaleDateString(
                            'en-US',
                            {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            }
                          )}
                        </>
                      ) : (
                        ''
                      )}

                      {/* Tooltip */}
                      {isToolTipOpen === user._id && (
                        <div className='absolute top-10 left-[-40px] mt-2 bg-white p-4 rounded shadow-lg border z-[9999]'>
                          <p className='text-gray-700'>
                            Do you really want to delete this user?
                          </p>
                          <div className='flex justify-between mt-4'>
                            <button
                              className='px-3 py-1 bg-gray-300 rounded hover:bg-gray-400'
                              onClick={closeToolTip}
                            >
                              Cancel
                            </button>
                            <button
                              className='px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600'
                              onClick={() => confirmDelete(user._id)}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {isOpen && (
            <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
              <div className='bg-white p-4 rounded-lg shadow-lg text-center'>
                <h2 className='text-lg font-bold text-center'>QR Code</h2>
                <img
                  className='w-40 h-40 mx-auto my-4'
                  src={QRCode}
                  alt='QR Code'
                />
                <button
                  onClick={() => {
                    setIsOpen(false);
                  }}
                  className='text-center bg-red-500 text-white px-4 py-2 rounded-md'
                >
                  Close
                </button>
              </div>
            </div>
          )}
          {/* Edit Modal */}
          {editUser && (
            <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
              <div className='bg-white p-6 rounded-lg shadow-lg w-1/3'>
                <h2 className='text-xl font-bold mb-4'>Edit User</h2>
                <div className='mb-4'>
                  <label className='block text-gray-700'>Name</label>
                  <input
                    type='text'
                    className='w-full p-2 border border-gray-300 rounded'
                    value={editUser.name}
                    onChange={(e) =>
                      setEditUser({ ...editUser, name: e.target.value })
                    }
                  />
                </div>

                <div className='mb-4'>
                  <label className='block text-gray-700'>Phone</label>
                  <input
                    type='text'
                    className='w-full p-2 border border-gray-300 rounded'
                    value={editUser.phone}
                    onChange={(e) =>
                      setEditUser({ ...editUser, phone: e.target.value })
                    }
                  />
                </div>
                <div className='mb-4'>
                  <label className='block text-gray-700'>Email</label>
                  <input
                    type='email'
                    className='w-full p-2 border border-gray-300 rounded'
                    value={editUser.email}
                    onChange={(e) =>
                      setEditUser({ ...editUser, email: e.target.value })
                    }
                  />
                </div>

                <div className='mb-4'>
                  <label className='block text-gray-700'>User Type</label>
                  <select
                    className='w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                    value={editUser.userType}
                    onChange={(e) =>
                      setEditUser({ ...editUser, userType: e.target.value })
                    }
                  >
                    <option
                      value=''
                      disabled
                    >
                      Select a user type
                    </option>
                    <option value='Admin'>Admin</option>
                    <option value='ProLeadPartner'>Pro Lead Partner</option>
                    <option value='Employee'>Employee</option>
                  </select>
                </div>

                <div className='flex justify-end'>
                  <button
                    className='px-4 py-2 bg-gray-300 rounded mr-2'
                    onClick={() => setEditUser(null)}
                  >
                    Cancel
                  </button>
                  <button
                    className='px-4 py-2 bg-blue-500 text-white rounded'
                    onClick={handleSaveEdit}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          )}

          {isModelOpen && (
            <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
              <div className='bg-white p-6 rounded-lg shadow-lg w-[700px]'>
                <h2 className='text-lg font-semibold mb-4'>
                  <strong className='text-[blue]'>{userName}</strong> Lead's
                  Data
                </h2>

                {/* Table */}
                <table className='w-full border-collapse border border-gray-300'>
                  <thead>
                    <tr className='bg-gray-200'>
                      <th className='border p-2'>Type</th>
                      <th className='border p-2'>Register Date</th>
                      <th className='border p-2'>Policy Uploaded</th>
                      <th className='border p-2'>Activity Points</th>
                      <th className='border p-2'>Payment Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leads.length > 0 ? (
                      leads.map((lead) => (
                        <tr
                          key={lead.id}
                          className='text-center'
                        >
                          <td className='border p-2'>{lead.vehicleType}</td>
                          <td className='border p-2'>
                            {new Date(lead.registrationDate).toLocaleDateString(
                              'en-US',
                              {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                              }
                            )}
                          </td>
                          <td className='border p-2'>
                            {lead.policyUploaded ? '☑' : '✖'}
                          </td>
                          <td
                            className={
                              lead?.paymentVarified
                                ? 'border p-2 text-green-600 font-bold'
                                : 'border p-2 text-red-600 font-bold'
                            }
                          >
                            <strong>
                              {lead.paymentDetail?.activityPointsReceived}
                            </strong>
                          </td>
                          <td className='border p-2'>
                            {new Date(lead.paymentDate).toLocaleDateString(
                              'en-US',
                              {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                              }
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={5}
                          className='text-center py-4 text-gray-500'
                        >
                          No leads found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Close Button */}
                <button
                  onClick={() => setIsModelOpen(false)}
                  className='mt-4 px-4 py-2 bg-blue-500 text-white rounded w-full'
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {isModalOpen && (
            <div
              className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'
              onClick={() => setIsModalOpen(false)} // Close modal on outside click
            >
              <div
                onClick={(e) => e.stopPropagation()} // Prevent click from propagating
                className='bg-white rounded-lg shadow-lg p-6 w-96'
              >
                <h2 className='text-xl font-bold mb-4'>Add Employees</h2>
                <form onSubmit={handleSubmit}>
                  <div className='mb-4'>
                    <input
                      type='text'
                      name='name'
                      placeholder='Enter user name'
                      className='w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='mb-4'>
                    <input
                      type='email'
                      name='email'
                      placeholder='Enter user email'
                      className='w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='mb-4'>
                    <input
                      type='password'
                      name='password'
                      placeholder='Enter password'
                      className='w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='mb-4'>
                    <input
                      type='text'
                      disabled
                      name='employeeCode'
                      placeholder='Enter employee code (e.g., E001)'
                      className='w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                      value={formData.employeeCode}
                      onChange={handleChange}
                    />
                  </div>

                  <div className='flex justify-end space-x-2'>
                    <button
                      type='button'
                      onClick={() => setIsModalOpen(false)}
                      className='px-4 py-2 bg-gray-300 text-black rounded-lg hover:bg-gray-400'
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className='px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600'
                    >
                      Add User
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
          <div className='absolute bottom-2 right-8'>
            <button
              onClick={logout}
              className='px-4 py-2 bg-[#1E90FE] text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-colors duration-300 ease-in-out cursor-pointer'
            >
              Logout
            </button>
          </div>
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Circles
            height='40'
            width='40'
            color='#1E90FF'
            ariaLabel='loading'
          />
        </div>
      )}

      {openModal && (
        <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
          <div className='bg-white p-6 rounded-lg shadow-lg w-[800px]'>
            <div className='flex flex-col sm:flex-row justify-between items-center mb-4 gap-2'>
              {/* Title aligned to the start */}
              <h2 className='text-lg font-bold'>Activity Points History</h2>

              {/* Buttons aligned to the end */}
              <div className='flex items-center gap-2'>
                <DatePicker
                  selected={date.startDate}
                  onChange={(dates) => {
                    const [start, end] = dates || []; // Handle null values
                    setDate({ startDate: start, endDate: end });

                    if (start && end) {
                      dispatch(
                        getAllUsersPaymentDoneLead({
                          startDate: start,
                          endDate: end,
                        })
                      );
                    }
                  }}
                  startDate={date.startDate}
                  endDate={date.endDate}
                  selectsRange
                  placeholderText='Start Date - End Date'
                  className='px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-black w-full sm:w-auto'
                />

                <button
                  className='px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition'
                  onClick={() => {
                    donwnloadNewExcel();
                  }}
                >
                  Download Excel
                </button>
              </div>
            </div>

            {/* Paid Requests Table */}
            <div className='max-h-80 overflow-y-auto border border-gray-300 rounded-lg'>
              <table className='w-full border-collapse'>
                <thead className='sticky top-0 bg-gray-200'>
                  <tr>
                    <th className='border border-gray-300 px-4 py-2'>User</th>
                    <th className='border border-gray-300 px-4 py-2'>UPI ID</th>
                    <th className='border border-gray-300 px-4 py-2'>
                      Payment Date
                    </th>
                    <th className='border border-gray-300 px-4 py-2'>
                      Payment Detail
                    </th>
                    <th className='border border-gray-300 px-4 py-2'>
                      Activity Piont (Verification)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {paidRequests.length > 0 ? (
                    paidRequests.map((request) => (
                      <tr
                        key={request.id}
                        className='text-center text-sm'
                      >
                        <td className='border border-gray-300 px-2 py-1 text-sm'>
                          <div className='flex items-center gap-2'>
                            {/* Profile Image */}
                            {request?.userDetails?.profilePhoto && (
                              <img
                                src={
                                  request?.userDetails?.profilePhoto ||
                                  '/default-avatar.png'
                                }
                                alt='Profile'
                                className='w-8 h-8 rounded-full object-cover'
                              />
                            )}
                            {/* User Name & Phone */}
                            <div className='flex flex-col'>
                              <span className='font-semibold'>
                                {request?.userDetails?.name}
                              </span>
                              <span className='text-xs text-gray-500'>
                                {request?.userDetails?.phone}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td
                          className='border border-gray-300 px-2 py-1 cursor-pointer text-blue-600 hover:underline'
                          onClick={() => {
                            navigator.clipboard.writeText(
                              request?.userDetails?.upiID
                            );
                            toast.success('UPI ID copied!');
                          }}
                        >
                          {request?.userDetails?.upiID}
                        </td>

                        <td className='border border-gray-300 px-2 py-1'>
                          {formatDate(request.requestData?.paymentDate)}
                        </td>

                        <td className='border border-gray-300 px-2 py-1 text-sm'>
                          <div className='flex items-center gap-2'>
                            {/* Profile Image */}
                            {request.requestData?.paymentDetail
                              ?.companyLogo && (
                              <img
                                src={
                                  request.requestData?.paymentDetail
                                    ?.companyLogo || '/default-avatar.png'
                                }
                                alt='Profile'
                                className='w-8 h-8 rounded-full object-cover'
                              />
                            )}
                            {/* User Name & Phone */}
                            <div className='flex flex-col'>
                              <span className='font-semibold'>
                                {
                                  request.requestData?.paymentDetail
                                    ?.companyName
                                }
                              </span>
                              <span className='text-xs text-gray-500'>
                                ₹
                                {
                                  request?.requestData?.paymentDetail
                                    .premiumAmount
                                }
                                ,{' '}
                                {
                                  request?.requestData?.paymentDetail
                                    .activityPointsReceived
                                }
                              </span>
                            </div>
                          </div>
                        </td>

                        <td className='border border-gray-300 px-2 py-1 text-center'>
                          <span
                            className={`px-3 py-1 text-xs font-semibold rounded-full 
      ${
        request?.requestData?.paymentVarified
          ? 'bg-green-100 text-green-700' // ✅ Done (Green)
          : 'bg-yellow-100 text-yellow-700' // ⏳ Pending (Yellow)
      }`}
                          >
                            {request?.requestData?.paymentVarified
                              ? '✅ Done'
                              : '⏳ Pending'}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan='3'
                        className='border border-gray-300 px-4 py-2 text-center'
                      >
                        No paid requests found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Close Button */}
            <button
              onClick={() => setOpenModal(false)}
              className='mt-4 px-4 py-2 bg-red-500 text-white rounded-lg w-full'
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivityPoints;
